import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../../components/components.module';
import { MesLogementsComponent } from './mes-logements.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogementEditComponent } from './logement-edit/logement-edit.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NoLogementGuard } from "../../guards/no-logement-guard.service";
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';
import { OwnerAddComponent } from './owner-add/owner-add.component';


@NgModule({
  declarations: [MesLogementsComponent, LogementEditComponent, OwnerAddComponent],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: MesLogementsComponent,
                canActivate: [NoLogementGuard]
            },
            {
                path: 'creer',
                component: LogementEditComponent,
            },
            {
                path: 'modifier/:id',
                component: LogementEditComponent
            },
            {
                path: 'ajout-proprietaire/:id',
                component: OwnerAddComponent
            }
        ]),
        NgbModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        NgxMatomoTrackerModule,
    ]
})
export class MesLogementsModule {
}
